import React, { forwardRef, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  GUIDING_PRINCIPLES_DIVESTITURES_TITLE,
  GUIDING_PRINCIPLES_TITLE,
  MATURITY_ASSESSMENT_TITLE,
} from '@model';
import { useLocation } from 'react-router-dom';
import { getDefaultOptions } from '@modules/systemSetting/systemModule/helper';

const MainSectionInput = forwardRef((props, ref) => {
  const cellObj =
    props.formInstance?.getFieldValue?.([props.rowName, props.rowIndex]) || {}; // ✅ Provide default empty object

  const {
    value: v,
    module,
    type = 'default', // ✅ Provide default values
    originPermissions,
  } = cellObj;

  const [options, setOptions] = useState([]);

  const isCustomizePermission = type !== 'default';
  const location = useLocation();

  // debugger;
  const companyInstance = useSelector(
    (state) => state.common.projectCompanyInfo.instanceType,
  );
  const settingCompanyInstance = useSelector(
    (state) => state.common.settingCompanyInstance,
  );
  const onProjectSetting = location?.pathname.includes('projects/setting');
  const projectType = onProjectSetting
    ? companyInstance
    : settingCompanyInstance;
  const defaultOptions = useMemo(
    () =>
      getDefaultOptions({
        key: v,
        moduleName: module,
        location,
        isCustomizePermission,
        originPermissions,
      }),
    [v, isCustomizePermission, originPermissions],
  );

  useEffect(() => {
    if (!module) {
      setOptions(['Module Name']);
      return;
    }
    if (isCustomizePermission && module) {
      setOptions([module]);
      // onChange([v]);
    }

    if (!isCustomizePermission && module && defaultOptions) {
      const nextOptions = defaultOptions
        ?.map((item) => {
          const { label: title } = item;
          if (title === MATURITY_ASSESSMENT_TITLE) {
            return projectType === 'Divestiture'
              ? 'Separation Readiness Assessment'
              : projectType === 'Integration'
              ? 'Integration Readiness Assessment'
              : 'Readiness Assessment';
          }
          if (
            projectType === 'Customize' &&
            title === GUIDING_PRINCIPLES_TITLE
          ) {
            return 'Guiding Principles';
          }
          if (
            projectType === 'Customize' &&
            title === GUIDING_PRINCIPLES_DIVESTITURES_TITLE
          ) {
            return null;
          }
          return title;
        })
        .filter((e) => e);
      setOptions(nextOptions);
    }
  }, [module, projectType, defaultOptions]);

  return (
    <div className="mainSection-group">
      {options.map((item, index) => (
        <span className="mainSection-span" key={index}>
          {item}
        </span>
      ))}
    </div>
  );
});
export default MainSectionInput;
